export const all_routes = {
  // dashboard routes
  adminDashboard: "/employee-dashboard",
  employeeDashboard: "/employee-dashboard",
  leadsDashboard: "/leads-dashboard",
  dealsDashboard: "/deals-dashboard",

  calendar: "/calendar",
  dataTables: "/data-tables",
  tablesBasic: "/tables-basic",
  notes: "/notes",

  //thoughts
  thoughts: "/api/admin/thoughts/view",

  //page module
  starter: "/starter",
  profile: "/pages/profile",
  orgProfile: "/pages/profile/:id",
  gallery: "/gallery",
  gallerydetails: "/gallery-details",
  searchresult: "/search-result",
  timeline: "/timeline",
  pricing: "/pricing",
  comingSoon: "/coming-soon",
  underMaintenance: "/under-maintenance",
  underConstruction: "/under-construction",
  error404: "/error-404",
  error500: "/network-error",
  internalserverError: "/error-500",
  NoInternet: "/no-internet",
  TimeoutPage: "/timeout",
  apikey: "/api-keys",
  privacyPolicy: "/key-policy",
  termscondition: "/terms-condition",

  // auth routes routes
  login: "/login",
  login2: "/login-2",
  login3: "/login-3",
  register: "/register",
  register2: "/register-2",
  register3: "/register-3",
  forgotPassword: "/forgot-password",
  ChangePassword: "/change-password",
  forgotPassword2: "/forgot-password-2",
  forgotPassword3: "/forgot-password-3",
  twoStepVerification: "/two-step-verification",
  twoStepVerification2: "/two-step-verification-2",
  twoStepVerification3: "/two-step-verification-3",
  success: "/success",
  emailVerification: "/email-verification",
  emailVerification2: "/email-verification-2",
  emailVerification3: "/email-verification-3",
  lockScreen: "/lock-screen",
  resetPassword: "/reset-password",
  resetPassword2: "/reset-password-2",
  resetPassword3: "/reset-password-3",
  resetPasswordSuccess: "/success",
  resetPasswordSuccess2: "/success-2",
  resetPasswordSuccess3: "/success-3",

  //ui routes
  alert: "/ui-alert",
  accordion: "/ui-accordion",
  avatar: "/ui-avatar",
  badges: "/ui-badges",
  border: "/ui-border",
  breadcrums: "/ui-breadcrums",
  button: "/ui-buttons",
  buttonGroup: "/ui-button-group",
  cards: "/ui-cards",
  carousel: "/ui-carousel",
  colors: "/ui-colors",
  dropdowns: "/ui-dropdowns",
  grid: "/ui-grid",
  digitalassets: "/digital-assets/:base",
  lightbox: "/ui-lightbox",
  media: "/ui-media",
  modals: "/ui-modals",
  navTabs: "/ui-navtabs",
  offcanvas: "/ui-offcanvas",
  pagination: "/ui-pagination",
  placeholder: "/ui-placeholder",
  popover: "/ui-popover",
  progress: "/ui-progress",
  rangeSlider: "/ui-rangeslider",
  spinner: "/ui-spinner",
  sweetalert: "/sweetalert",
  toasts: "/ui-toasts",
  tooltip: "/ui-tooltip",
  typography: "/ui-typography",
  video: "/ui-video",
  clipboard: "/ui-clipboard",
  counter: "/ui-counter",
  dragandDrop: "/ui-drag-drop",
  rating: "/ui-rating",
  ribbon: "/ui-ribbon",
  stickyNotes: "/ui-sticky-notes",
  textEditor: "/ui-text-editor",
  timeLine: "/ui-timeline",
  scrollBar: "/ui-scrollbar",
  apexChart: "/ui-apexchart",
  primeChart: "/ui-prime-chart",
  chartJs: "/ui-chart-js",

  chart: "/ui-chartjs",
  featherIcons: "/ui-feather-icon",
  falgIcons: "/ui-flag-icon",
  fontawesome: "/ui-fontawesome",
  materialIcon: "/ui-material-icon",
  pe7icon: "/ui-icon-pe7",
  simpleLineIcon: "/ui-simpleline",
  themifyIcon: "/ui-themify",
  typicon: "/ui-typicon",
  weatherIcon: "/ui-weather-icon",
  basicInput: "/forms-basic-input",
  checkboxandRadion: "/form-checkbox-radios",
  inputGroup: "/form-input-groups",
  gridandGutters: "/form-grid-gutters",
  formSelect: "/form-select",
  formMask: "/form-mask",
  fileUpload: "/form-fileupload",
  horizontalForm: "/form-horizontal",
  formPicker: "/form-pickers",
  verticalForm: "/form-vertical",
  floatingLable: "/form-floating-labels",
  formValidation: "/form-validation",
  reactSelect: "/select",
  formWizard: "/form-wizard",
  iconicIcon: "/icon-ionic",
  sortable: "/ui-sortable",
  swiperjs: "/ui-swiperjs",
  bootstrapIcons: "/icon-bootstrap",
  RemixIcons: "/icon-remix",
  FlagIcons: "/icon-flag",

  //base-ui
  uiAlerts: "/ui-alerts",
  uiAccordion: "/ui-accordion",
  uiAvatar: "/ui-avatar",
  uiBadges: "/ui-badges",
  uiBorders: "/ui-borders",
  uiButtons: "/ui-buttons",
  uiButtonsGroup: "/ui-buttons-group",
  uiBreadcrumb: "/ui-breadcrumb",
  uiCards: "/ui-cards",
  uiCarousel: "/ui-carousel",
  uiColor: "/ui-color",
  uiDropdowns: "ui-dropdowns",

  //Maps
  mapLeaflet: "/map-leaflet",

  // settings routes
  customFields: "/app-settings/custom-fields",
  invoiceSettings: "/app-settings/invoice-settings",

  currencies: "/financial-settings/currencies",
  paymentGateways: "/financial-settings/payment-gateways",
  taxRates: "/financial-settings/tax-rates",

  schoolSettings: "/academic-settings/school-settings",
  religion: "/academic-settings/religion",

  connectedApps: "/general-settings/connected-apps",
  notificationssettings: "/general-settings/notifications-settings",
  profilesettings: "/general-settings/profile-settings",
  securitysettings: "/general-settings/security-settings",

  communication: "/profile-update/communication",
  personal: "/profile-update/personal",
  familyDependentDetails: "/profile-update/family-dependent-details",
  languageProficiency: "/profile-update/language-proficiency",
  previousWork: "/profile-update/previous-work-experience",
  education: "/profile-update/education",
  nominationsPf: "/profile-update/nominations-pf",
  nominationsGratuity: "/profile-update/nominations-gratuity",
  mycompession: "/profile-update/my-compession",
  mypayslip: "/profile-update/my-payslip",
  prevsubmit: "/sumbit-organization-details",

  companySettings: "/website-settings/company-settings",
  miscellaneous: "/profile-update/miscellaneous-details",
  addLanguage: "/website-settings/add-language",

  localization: "/website-settings/localization",

  salarySettings: "/app-settings/salary-settings",
  approvalSettings: "/app-settings/approval-settings",
  leaveType: "/app-settings/leave-type",

  banIpAddress: "/other-settings/ban-ip-address",
  customCss: "/other-settings/custom-css",
  customJs: "/other-settings/custom-js",
  cronjob: "/other-settings/cronjob",
  Cronjobschedule: "/other-settings/cronjob-schedule",
  storage: "/other-settings/storage-settings",
  backup: "/other-settings/backup",
  clearcache: "/other-settings/clear-cache",

  emailSettings: "/system-settings/email-settings",
  emailTemplates: "/system-settings/email-templates",
  gdprCookies: "/system-settings/gdpr-cookies",
  smsSettings: "/system-settings/sms-settings",
  smsTemplate: "/system-settings/sms-template",
  otpSettings: "/system-settings/otp-settings",
  maintenanceMode: "/system-settings/maintenance-mode",

  //content routes
  pages: "/content/pages",
  countries: "countries",
  states: "/content/states",
  cities: "/content/cities",
  testimonials: "testimonials",
  faq: "https://team1consulting.tawk.help",

  // blog
  blogs: "blogs",
  blogCategories: "blog-categories",
  blogComments: "blog-comments",
  blogTags: "blog-tags",

  //userManagement routes
  deleteRequest: "/user-management/delete-request",
  rolesPermissions: "/user-management/roles-permissions",
  manageusers: "/user-management/manage-users",
  permissions: "/user-management/permissions",

  //support routes
  contactMessages: "/support/contact-messages",
  tickets: "/tickets/ticket-list",
  ticketGrid: "/tickets/ticket-grid",
  ticketList: "/support/ticket-list",
  ticketDetails: "/tickets/ticket-details",

  // Performance
  pmsGrid: "/pms-Grid",
  performanceIndicator: "/performance/performance-indicator",
  performanceReviewManager: "/performance/performance-review-manager",
  performanceAppraisal: "/preformance/performance-appraisal",
  goalTracking: "/performance/goal-tracking",
  goalType: "/performance/goal-type",

  // Goal
  performanceReview: "/performance/performance-review",
  goalsProfileupdate: "/pms-goals-profile-update/:financial_year",
  userguide: "/user-guide",
  appraisalLetter: "/appraisal-letter",
  goalsSummary: "/pms-goals-summary",
  kraProfile: "/pms-kra-profile/:financial_year",
  behaviouralCompetency: "/pms-behavioural-Competence/:financial_year",
  goalsProfile: "/pms-goals-profile/:financial_year",
  allEmployeeGoals: "/pms-employee-goals",
  employeegoalsSummary: "/pms-employee-goals-profile/:id",
  employeeperformanceReview: "/pms-employee-performance-review/:id",
  pmsCareerAspirations: "/pms-career-aspirations/:financial_year",

  // Training

  trainingList: "/training/training-list",
  trainers: "/training/trainers",
  trainingType: "/training/training-type",

  // membership routes
  membershipplan: "/membership-plans",
  membershipAddon: "/membership-addons",
  membershipTransaction: "/membership-transactions",

  layoutDefault: "/layout-default",
  layoutMini: "/layout-mini",
  layoutRtl: "/layout-rtl",
  layoutBox: "/layout-box",
  layoutDark: "/layout-dark",
  Horizontal: "/layout-horizontal",
  Detached: "/layout-detached",
  Hovered: "/layout-hovered",
  Boxed: "/layout-box",
  Modern: "/layout-modern",
  TwoColumn: "/layout-twocolumn",
  HorizontalSingle: "/layout-horizontal-single",
  HorizontalOverlay: "/layout-horizontal-overlay",
  HorizontalBox: "/layout-horizontal-box",
  MenuAside: "/layout-horizontal-sidemenu",
  Transparent: "/layout-transparent",
  WithoutHeader: "/layout-without-header",
  RTL: "/layout-rtl",
  Dark: "/layout-dark",

  // finance & accounts routes
  accountsIncome: "/accounts/accounts-income",
  accountsInvoices: "/accounts/accounts-invoices",
  accountsTransactions: "/accounts/accounts-transactions",
  expense: "/accounts/expense",
  expenseCategory: "/accounts/expense-category",

  addInvoice: "/accounts/add-invoice",
  editInvoice: "/accounts/edit-invoice",
  categories: "/accounting/categories",
  budgets: "/accounting/budgets",
  budgetexpenses: "/accounting/budgets-expenses",
  budgetrevenues: "accounting/budget-revenues",

  //crm

  clientgrid: "/clients-grid",
  clientlist: "/clients",
  clientdetils: "/clients-details",
  project: "/projects-grid",
  projectlist: "/projects",
  projectdetails: "/projects-details",
  tasks: "/tasks",
  tasksdetails: "/task-details",
  engagementcalendar: "/engagement-calendar",
  contactGrid: "/contact-grid",
  contactList: "/contact-list",
  contactDetails: "/contact-details",
  companiesGrid: "/companies-grid",
  companiesList: "/companies-list",
  companiesDetails: "/companies-details",
  dealsGrid: "/deals-grid",
  dealsList: "/deals-list",
  dealsDetails: "/deals-details",
  leadsList: "/leads-list",
  leadsGrid: "/leads-grid",
  leadsDetails: "/leads-details",
  pipeline: "/pipeline",
  analytics: "/analytics",
  activities: "/",

  //HRM
  employeedirectory: "/employee-directory",
  organisationstructure: "/organisation-structure",
  orgStructure: "/our_organization",
  funStructure: "/functional_structure",
  organisation: "/organisation",
  whoarewe: "/who-are-we",
  cultureandpeople: "/culture-and-people-strategy",
  overValue: "/our-values",
  ourmission: "/mission-vision",
  employeeGrid: "/employees-grid",
  departments: "/departments",
  designations: "/designations",
  policy: "/policy",
  holidays: "/holidays",
  leaveadmin: "/leaves",
  selfhelp: "/self-help",
  leavesettings: "/leave-settings",
  attendanceadmin: "/attendance-admin",
  attendanceemployee: "/attendance-employee",
  timesheet: "/timesheets",
  timesheetlog: "/timesheet-logs/:id",
  timesheetlogemployee: "/employee-time-logs/:id",
  scheduletiming: "/schedule-timing",
  overtime: "/overtime",
  promotion: "/promotion",
  resignation: "/resignation",
  termination: "/termination",

  // RECRUITMENT
  jobgrid: "/jobs",
  jobdescription: "/job-description",
  jobrefrence: "/job-refrence",
  joblist: "/job-list",
  noticecirculars: "/notice-circulars",
  announcements: "/announcements",
  employeeSpeak: "/employee-speak",
  candidateslist: "/candidates",
  candidateskanban: "/candidates-kanban",
  refferal: "/job-refferals",
  supportteam: "/support-team",
  trainingcalnder: "/training-calender",
  allnominations: "/nominations",
  travell: "/expense",
  travelrequest: "/expense-request",
  edittravelrequest: "/edit-expense-request",
  insurance: "/insurance",
  recognition: "/recognition",
  groupPersonalAccident: "/GPA-key-information",
  mycoverage: "/my-coverages",
  downloadecard: "/download-e-card",
  healthInsuranceCorner: "/health-insurance-corner",
  premiumeligibility: "/premium-eligibility",
  policyInformation: "/policy-information",
  customerInformationSheet: "/customer-information-sheet",
  claimprocedures: "/claim-procedures",
  grievance: "/grievance",
  sops: "/sops",
  elibrary: "/e-library",
  surveypolls: "/survey-polls",
  annualgoal: "/annual-goal",
  monthlyassesment: "/monthly-assesment",
  wetalk: "/we-talk",

  // faq:"https://team1consulting.tawk.help/",

  //FINANCE & ACCOUNTS
  estimate: "/estimates",
  invoices: "/invoices",
  addinvoice: "/add-invoices",
  editinvoice: "/edit-invoices",
  invoicesdetails: "/invoice-details",
  payments: "/payments",
  expenses: "/expenses",
  providentfund: "/provident-fund",
  taxes: "/taxes",
  invoiceDetails: "/invoice-details",
  employeesalary: "/employee-salary",
  compensation: "/compensation",
  payrollAddition: "/payroll",
  payrollOvertime: "/payroll-overtime",
  payrollDeduction: "/payroll-deduction",
  //ADMINISTRATION
  knowledgebase: "/knowledgebase",
  activity: "/activity",
  users: "/users",
  rolePermission: "/roles-permissions",
  permissionpage: "/permission",
  assetCategories: "/asset-categories",
  assetList: "/assets",
  //Report
  expensesreport: "/expenses-report",
  invoicereport: "/invoice-report",
  paymentreport: "/payment-report",
  projectreport: "/project-report",
  taskreport: "/task-report",
  userreport: "/user-report",
  employeereport: "/employee-report",
  employeedetails: "/employee-details",
  employeedetailsWithId: "/employee-details/:id", // for individual employee detail
  payslipreport: "/payslip-report",
  attendancereport: "/attendance-report",
  leavereport: "/leave-report",
  dailyreport: "/daily-report",

  // Attendance
  attendanceGrid: "/attendance-dashboard",
  attendanceTeamDashboard: "/team-attendance-dashboard",
  selfattendance: "/attendance-calender",
  selfattendancehis: "/attendance-history",
  myattendanceCalender: "/attendance-calenders",
  markmyattendance: "/mark-attendance",
  myattendanceRegularization: "/attendance-regularization",

  RegularizationTeam: "/team-attendance-regularization",
  teamattendancehis: "/team-attendance-history",
  ViewattendanceTeam: "/team-attendance-calender",

  // Self Leave
  seflGrid: "/self-leave",
  selfLeaveApply: "/leave-application",
  editLeaveApplication: "/edit-leave-application",
  selfLeaveDetails: "/leave-details",
  selfleaveBalance: "/leave-balance",
  leaveReportCoordinator: "/coordinator-leave-report",
  leaveJvCoordinator: "/coordinator-leave-jv",
  selfleaveCalender: "/leave-calender",
  selfLeaveDashboard: "/self-leave-dashboard",

  // Team Leave
  teamGrid: "/team-leave",
  teamleaveStatus: "/team-leave-status",
  teamleaveTeamMember: "/apply-leave-team-member",
  teamleaveDetailsTeamMember: "/leave-details-team-member",
  teamleaveBalanceTeamMember: "/leave-balance-team-member",
  teamleaveCalender: "/team-leave-calender",
  teamMemberleave: "/leave-team-member",
  leaveReport: "/leave-report",
  teamLeaveDashboard: "/team-leave-dashboard",

  // Leave Cordinator
  empsupleaveApplication: "/emp-sup-leave-application",
  empsupleaveDetails: "/emp-sup-leave-details",
  empsupleaveBalance: "/emp-sup-leave-balance",
  empsupteamleaveStatus: "/all-leave-status",
  empsupleaveTeamMember: "/leave-all-member",
  empsupteamleaveCalender: "/emp-sup-team-leave-calender",
  empsupleaveReport: "/emp-sup-leave-report",
  empsupleavedelegate: "/emp-sup-leave-delegate-to",

  // out duty
  selfOutDutyGrid: "/self-out-duty",
  outdutyApplication: "/out-duty-application",
  editoutdutyApplication: "/edit-out-duty-application",
  outdutyDetails: "/out-duty-details",
  selfOutDutyDashboard: "/self-out-duty-dashboard",

  // Team outDuty
  teamOutDutyGrid: "/team-out-duty",
  outdutyTeamStatus: "/out-duty-team-status",
  applyoutdutyTeamMember: "/apply-outduty-team-member",
  outdutyTeamMember: "/out-duty-team-member",
  outdutyReport: "/out-duty-report",
  outdutyDetailsTeamMember: "/outduty-details-team-member",
  outdutyCalenderTeamMember: "/outduty-calender-team-member",

  outdutyCalender: "/out-duty-calender",
  outdutyReportCoordinator: "/coordinator-out-duty-report",

  empsupoutdutyApplication: "/emp-sup-out-duty-application",
  empsupoutdutyDetails: "/emp-sup-out-duty-details",
  empsupoutdutyTeamStatus: "/out-duty-all-status",
  empsupoutdutyTeamMember: "/out-duty-all-member",
  empsupoutdutyTeamCalender: "/emp-sup-out-duty-team-calender",
  empsupoutdutyReport: "/emp-sup-out-duty-report",

  //Team Attendance
  attendanceAdmin: "/attendance-admin",
  attendanceAdminCurrentRoster: "/attendance-admin-current-sattus",
  attendanceAdminCalender: "/attendance-admin-calender",
  attendanceAdminRegularization: "/attendance-admin-regularization",
  attendanceAdminRegularizationTeam: "/attendance-team-regularization",
  attendanceAdminRosterManager: "/attendance-admin-roster-manager",
  attendanceAdminReport: "/attendance-admin-report",
  attendanceAdminSummaryReport: "/attendance-admin-summary-report",

  attendanceEmpSup: "/attendance-emp-sup",
  attendanceEmpSupCurrentRoster: "/attendance-emp-sup-current-status",
  attendanceEmpSupCalender: "/attendance-emp-sup-calender",
  attendanceEmpSupRegularization: "/attendance-emp-sup-regularization",
  attendanceEmpSupRegularizationTeam: "/all-attendance-regularization",
  attendanceEmpSupViemTeam: "/view-all-attendance",
  attendanceEmpSupRosterManager: "/attendance-emp-sup-roster-manager",
  attendanceEmpSupReport: "/attendance-emp-sup-report",
  attendanceEmpSupSummaryReport: "/attendance-emp-sup-summary-report",
  attendanceEmpSupNewRoster: "/attendance-emp-sup-new-roster",
  attendanceEmpSupCurrentRosters: "/attendance-emp-sup-current-rosters",
  attendanceEmpSupReportRosterTeam: "/attendance-emp-sup-report-team-roster",

  // PMS
  pmscategory: "/pms-category",
  kra: "/kra",
  pmsKra: "/pms-kra",
  kraGoals: "/kra-goals",
  weightageKra: "/kra-weightage",
  assignKra: "/assign-kra",
  employeePmsReview: "/employee-kra-review",

  viewBehavioural: "/pms-behavioural-competency",
  defineBehaviouralCompetency: "/behavioural-weightage",
  goals: "/pms-goals",
  behaviouralEmployeeReview: "/employee-behavioural-review",

  // Trainer
  tainerList: "/trainer-list",
  createTraning: "/create-traning",
  addTrainer: "/add-trainer",

  // Trainer Employee
  employeeTraningList: "/employee-traning-list",
  nominationPage: "/nomination-page",
  employeeView: "/employee-view",
  assessment: "/assessment",
  manager: "/manager-view",

  selfmonthlyfeedback: "/monthly-feedback",
  teammonthlyfeedback: "/monthly-feedback-team-members",
  monthlyfeedback: "/monthly-feedback/:employee_id",

  // Payslip
  Payslip: "/paylip",

  // performance
  pmsReview: "/pms-review",
  pmsReviewManager: "/pms-review-manager/:employee_name/:employee_id",
  pmsAllEmployeeR1: "/pms-all-employee-r1",
  pmsReviewManagerR2: "/pms-review-manager-r2/:employee_name/:employee_id",
  pmsReviewManagerR1Employees: "/pms-review-manager-r1-employees/:manager_id",
  pmsAllEmployeeR2: "/pms-all-employee-r2",
  pmsReviewHod: "/pms-review-hod/:employee_id",
  pmsAllEmployeeHod: "/pms-all-employee-hod",

  // Compensation Route
  compensationPage: "/compensation",
  annexurePage: "/annexure",

  // Resignation Application
  //EXIT FORM
  exitoffboardingpage: "/self/offboarding/exitform",
  selfOffboarding: "/self/offboarding",
  teamoffboarding: "/team/offboarding",
  resignationList: "/resignation/list",
  offboardingForm: "/offboarding/add-form",
  // resignationViewEmployee: "/offboarding/view-offboarding",
  resignationView: "/offboarding/view-offboarding/:employeeId?",
  // ratingFeedbackForm1: "/resignation/ratingfeedback1",
  //Manager View
  resigantionApproval: "/resignation/resignationApproval",
  resigantionClearance: "/resignation/clearance/:employeeId?",
  managerView: "/offboarding/manager-view/:Id?",
  teamClearance: "/team/clearance",

  // Time Log Routes
  addProject: "/projects/add-project",
  editProject: "/projects/edit-project/:projectId",
  addTasks: "/tasks/add-task",
  editTasks: "/tasks/edit-task/:taskId",
  timeLogs: "/tasks/add-tasklogs",
  timeLogsDetails: "/tasks/tasklogs-details",

  //Recruitment
  RecruitmentDashboard: "/recruitment",
  MRP_FORM: "/man-power-recruitment/:id?",
  ViewRecuritment: "/view-recruitment",
  resumePreview: "/resume-preview",
  ViewRequitionForm: "/view-requisition/:id?",

  // Recuritment for manager
  ApprovalRequisition: "/recruitment-approval",
  // ApprovalPage: "/man-force-recruitment/:id?",
  DataBank: "/databank",
  SelectInterviwer: "/select-interviewer",

  employeePayslip: "/pay-slip",

  // ----- bhawna forms ------
  // employeeAssessmentForms: "/employee-assessment-forms",
  managerEnabledProbationAssessment: "/enabled-probation-forms",
  managerEnabledMonthlyAssessment: "/enabled-monthly-forms",
  buddyFeedbackForm: "/buddy-feedback-form",
  probationAssessmentForm: "/probation-assessment-form",
  probationAssessmentFormByID: "/probation-assessment-form-details",
  monthlyFeedbackFormByID: "/monthly-feedback-form-by-id",
  // monthlyOnboardingFeedbackForm: "/montly-onboarding-feedback-form",
  interviewAssessmentForm: "/interview-assessment-form",
  newJoiningForm: "/new-joining-form",

  inductionFeedbackForm: "/induction-feedback-form",
};
